import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "taDecimalPercentage",
  pure: true
})
export class DecimalPercentagePipe implements PipeTransform {
  transform(value: number, decimals?: number): number {
    if (isNaN(value)) {
      return 0;
    }

    if (value < 0.01) {
      return value;
    }

    return this.round(value, decimals || 2);
  }

  private round(value: number, decimals: number): number {
    const roundedTimes100 = Math.round(Number(`${value}e${decimals}`));
    return Number(`${roundedTimes100}e-${decimals}`);
  }
}
